import React, { useEffect, useState } from "react";
import { Col, Row, DatePicker, Form, FormInstance, Select, Input, Checkbox, Tag } from 'antd';
import dayjs from 'dayjs';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import { IMandatoDirigente } from "../../Componentes/InterfaceMandato";
import { IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import { hasPermissao, Papel } from "../../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  entidades: IEntidade[];
  dadosDirigente?: IMandatoDirigente;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}


const { Option } = Select;
const DiretorPerfil = ({ form, entidades, manter, dadosDirigente }: IProps) => {

  const [checkProrrogacao, setCheckProrrogacao] = useState(false)
  const [checkProrrogacaoNaBase, setCheckProrrogacaoNaBase] = useState(false)


  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      sigla: value.children,
      matriculaEfpc: value.key,
    });
  };

  const handlerCheckProrrogacao = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkProrrogacao": e.target.checked,
    });
    setCheckProrrogacao(e.target.checked);
  };

  useEffect(() => {
    if (dadosDirigente) {
      setCheckProrrogacao(dadosDirigente.prorrogacao);
      setCheckProrrogacaoNaBase(dadosDirigente.prorrogacao);
      form.setFieldsValue({
        "checkProrrogacao": dadosDirigente.prorrogacao,
      });

    }
  }, [dadosDirigente])

  return (
    <>
      <Row>
        <Col xs={4} xl={4} style={{ display: manter === 1 || manter === 9 ? 'none' : 'inline' }} >
          <Form.Item label="Situação"
            labelCol={{ span: 24 }}
            colon={false}
          >
            <Tag color={dadosDirigente?.situacaoVigencia ? "geekblue" : "volcano"} key={dadosDirigente?.idMandato}>
              {dadosDirigente?.situacaoVigencia && dadosDirigente.situacaoVigencia ? "ATIVO" : "INATIVO"}
            </Tag>
          </Form.Item>
        </Col>

        <Col xs={10} xl={10}>
          <Form.Item label="Entidade"
            labelCol={{ span: 24 }}
            name="sigla"
            colon={false}
            rules={[
              {
                required: true,
                message: "A entidade é obrigatória",
              },
            ]}
          >
            <Select
              disabled={manter !== 1 ? true : entidades.length === 1}
              showSearch
              filterOption
              optionFilterProp='children'
              placeholder='Selecione a entidade'
              onChange={(_, index) => {
                handlerEntidade(index);
              }}
            >
              {entidades?.map((e: IEntidade) => (
                <Option key={e.matricula} value={e.matricula}>
                  {e.sigla}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={10} xl={10}>
          <Form.Item label='Nome do Cargo'
            name='nmCargo'
            colon={false}
            rules={[
              {
                required: true,
                message: "Digite um cargo",
              },
            ]}
          >
            <Input
              disabled={manter === 2 ||  manter === 9 ? true : false}
              maxLength={100}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>

        <Col xs={8} xl={6}>
          <Form.Item label="Data Inicial do Mandato"
            name="dtInicioMandato"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 ||  manter === 9 || !hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Data Final do Mandato"
            name="dtFimMandato"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
              {
                validator: async (_, endDatetime) => {
                  let startDatetime = form.getFieldValue("dtInicioMandato");
                  if (endDatetime && startDatetime) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                    if (endDatetime <= startDatetime) {
                      return Promise.reject(
                        "Data de final do mandato deve ser maior do que à data inicial"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 ||  manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Início do Exercício"
            name="dtInicioExercicio"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                validator: async (_, dtInicioExercicio) => {
                  let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                  if (dtInicioExercicio && dtInicioMandato) {
                    dtInicioExercicio = dayjs(dtInicioExercicio).format("YYYY-MM-DD")
                    dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                    if (dtInicioExercicio < dtInicioMandato) {
                      return Promise.reject(
                        "Data de início do exercício deve ser maior ou igual à data de início do mandato"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 ||  manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Fim do Exercício"
            name="dtFimExercicio"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                validator: async (_, endDatetime) => {
                  let startDatetime = form.getFieldValue("dtInicioExercicio");
                  if (endDatetime && startDatetime) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                    if (endDatetime <= startDatetime) {
                      return Promise.reject(
                        "Data de final do exercício deve ser maior do que a data de inicial"
                      );
                    }
                  }
                },
              },
              {
                validator: async (_, endDatetime) => {
                  let dtFimMandato = form.getFieldValue("dtFimMandato");
                  if (endDatetime && dtFimMandato) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                    if (endDatetime > dtFimMandato) {
                      return Promise.reject(
                        "Data de final do exercício deve ser maior ou igual à data final do mandato"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 ||  manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={24} xl={4} style={{ display: manter === 1 ? 'none' : 'inline' }} >
          <Form.Item
            label=" "
            name="checkProrrogacao"
            colon={false}
          >
            <Checkbox
              disabled={(manter === 1 || manter === 2 ||  manter === 9) ? true : checkProrrogacaoNaBase || false}
              checked={checkProrrogacao}
              onChange={handlerCheckProrrogacao}
            >
              Prorrogação
            </Checkbox>
          </Form.Item>
        </Col>


      </Row>

    </>
  )
};

export default DiretorPerfil;